import { formatNumber } from '@shared/ui/Number';
import { formatDateAndTime } from '@shared/utils/date';
import { getFractionDigits } from './precision';
import type { Precision } from './types';
import { Unit } from './Unit';

export type TValue = string | number | Date | null | undefined;

export function formatValue(value: TValue, precision: Precision = 'medium') {
  // Strings are rendered verbatim — properties such as serial numbers must
  // not be coerced into locale-formatted numbers
  if (typeof value === 'string') {
    return value;
  }

  if (value instanceof Date) {
    return formatDateAndTime(value, {
      timeOptions: { timeStyle: 'medium' },
    });
  }

  return (
    formatNumber(value, {
      fractionDigits: getFractionDigits(precision),
    }) ?? '-'
  );
}

interface ValueProps {
  value: TValue;
  unit?: string;
  precision?: Precision;
}

const Value = ({ value, unit, precision }: ValueProps) => {
  const showUnit = value !== undefined && value !== null;

  return (
    <>
      {formatValue(value, precision)}
      {showUnit && (
        <>
          {' '}
          <Unit unit={unit} />
        </>
      )}
    </>
  );
};

export default Value;
